export const HOST = ['https://activity-test.ihuhoo.com/activity-us', 'https://activity.tradeup.com/activity-us'];

export const API = {
    getDeepLink: '/api/v1/internal/deep_link' // 获取deeplink链接
};
